module.exports = __webpack_public_path__ + "static/cara-comfortline-64ecf1dfb712c8528bb3e911693a3524.png";